<template>
      <div id="radios" class="enaot9" :class="[size, status]">
            <div
                  v-for="(option, i) in options"
                  :key="i"
                  class="item"
                  :class="{ selected: compare(option, value) }"
                  tabindex="0"
                  @click="readonly ? null : onClick(option)"
                  @keyup.enter="readonly ? null : onClick(option)"
                  @blur="$emit('blur')"
                  @focus="$emit('focus')"
                  :fup-data="`input/${option.value}`"
            >{{ option[nameKey] }}</div>
      </div>
</template>

<script>
export default {
	name: "j-base-radios",

	props: {
		value: {
			required: true,
			default: null,
			validator(val) {
				return val === null || typeof val === "string"
			}
		},
		options: {
			required: true,
			default: () => [],
			type: Array
		},
		size: {
			required: false,
			default: "medium",
			validator(val) {
				return (
					val === null ||
					[
						"xsmall",
						"small",
						"medium",
						"large",
						"xlarge"
					].includes(val)
				)
			}
		},
		status: {
			required: false,
			default: null,
			validator(val) {
				return (
					val === null ||
					["error", "success", "warning"].includes(val)
				)
			}
		},
		nameKey: {
			type: String,
			default: "name"
		},
		valueKey: {
			type: String,
			default: "value"
		},
		readonly: {
			default: false
		}
	},

	methods: {
		onClick(option) {
			this.$emit("input", option[this.valueKey])
		},

		compare(option, valueTwo) {
			if (option[this.valueKey] === valueTwo) return true
			else return false
		}
	}
}
</script>
<style src="./index.css" scoped />
